import { render, staticRenderFns } from "./qaitem.vue?vue&type=template&id=aa039d3e&"
import script from "./qaitem.vue?vue&type=script&lang=js&"
export * from "./qaitem.vue?vue&type=script&lang=js&"
import style0 from "./qaitem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports